<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    append-to-body
    title="选择产品工艺"
    width="900px"
    top="8vh"
  >
    <TableSelect
      :filter="filter"
      :selReset="true"
      ref="tableSelect"
      :columns="columns"
      module="basic"
      url="rtRouteMaterials"
      @select="selectMaterialsRoute"
      @reset="resetHandle"
    >
      <template slot="adSearch">
        <el-form :inline="true" ref="form" :model="filter">
          <el-form-item label="工艺路线" prop="routingName">
            <el-input v-model.trim="filter.routingName" placeholder="请输入工艺路线名称" clearable />
          </el-form-item>
        </el-form>
      </template>
    </TableSelect>
  </el-dialog>
</template>

<script>
import TableSelect from "@/components/TableSelect.vue";

export default {
  components: { TableSelect },
  data() {
    return {
      dialogVisible: false,
      filter: {
        routingName: "",
        materialNo: "",
        workCenterId: "",
      },
      columns: [
        {
          title: "编号",
          key: "routeMaterialNo",
          width: 120,
          align: "center",
        },
        {
          title: "名称",
          key: "routingName",
          width: 120,
          align: "center",
          tooltip: true,
        },
        {
          title: "物料编号",
          width: 120,
          align: "center",
          key: "materialNo",
        },
        {
          title: "物料名称",
          key: "materialName",
          minWidth: 360,
        },
        {
          title: "版本号",
          key: "versionNo",
          width: 80,
          align: "center",
        },
        {
          title: "操作",
          slot: "action",
          width: 80,
          align: "center",
          fixed: "right",
        },
      ],
    };
  },
  methods: {
    open(materialNo, workCenterId) {
      this.dialogVisible = true;
      this.filter.materialNo = materialNo;
      this.filter.workCenterId = workCenterId;
      this.$nextTick(() => {
        this.$refs.form.resetFields();
        this.$refs.tableSelect.loadData();
      });
    },

    selectMaterialsRoute(row) {
      this.dialogVisible = false;
      this.$emit("select", row);
    },

    // 重置特殊处理
    resetHandle() {
      this.filter.routingName = "";
      this.$refs.tableSelect.loadData();
    },
  },
};
</script>
